import { RoutesPaths } from "../../constants/user-routes"
import { RECEIPT_CONFIGURE_SLUGS } from "../ReceiptPage/constants/receipt-configure-slugs"

export const pagesConfig = {
  [RoutesPaths.dashboard.root]: {
    title: "Dashboard",
    description: "Here’s an overview of all alerts.",
    icon: "homesidebar",
    buttonText: "Watch tutorial",
    videoUrl: "https://www.youtube.com/watch?v=vBIyZCsxwkU"
  },
  [RoutesPaths.alerts.all]: {
    title: "Alerts",
    description: "View the status of all alerts.",
    icon: "alerts",
    buttonText: "Watch tutorial",
    videoUrl: "https://www.youtube.com/watch?v=Llzdv1Exymw"
  },
  // Integrate tab of Configure — Integrations' page header moved here with it,
  // "View logs" included.
  ...["processors", "subscriptions", "notifications"].reduce((acc, slug) => {
    acc[`${RoutesPaths.configure.root}/${slug}`] = {
      title: "Configure",
      description: "View and manage your enrollments, refunds, and integrations.",
      icon: "settings",
      queryParam: "integrations-logs",
      queryButtonText: "View logs"
    }
    return acc
  }, {}),
  [RoutesPaths.receipts.all]: {
    title: "Receipt",
    description: "Share purchase details with cardholders to prevent disputes.",
    icon: "receipt_bill"
  },
  [RoutesPaths.receipts.configure_profile]: {
    title: "Configure",
    description: "Set up the details cardholders see for each charge.",
    icon: "settings"
  },
  [RoutesPaths.receipts.configure_business]: {
    title: "Configure",
    description: "View and manage your enrollments and refund settings.",
    icon: "settings"
  },
  // Wizard steps plus the Business tab (CHA-10781) — every Configure URL shares
  // one page header.
  ...Object.values(RECEIPT_CONFIGURE_SLUGS).reduce((acc, slug) => {
    acc[RoutesPaths.receipts.configure_profile_hash(slug)] = {
      title: "Configure",
      description: "Set up the details cardholders see for each charge.",
      icon: "settings"
    }
    return acc
  }, {}),
  "/business_settings/integrations": {
    title: "Integrations",
    description: "Integrate your gateway to prevent chargebacks.",
    icon: "integrations",
    buttonText: "Watch tutorial",
    videoUrl: "https://www.youtube.com/watch?v=DQfWiW5ZIbg"
  },
  [RoutesPaths.credits]: {
    title: "Credits",
    description: "View the status of all credit requests.",
    icon: "alerts"
  },
  [RoutesPaths.perks]: {
    title: "Perks & Benefits",
    description: "Exclusive deals and discounts from our partners.",
    icon: "gift"
  },
  [RoutesPaths.configure.enrollment]: {
    title: "Configure",
    description: "View and manage your enrollments, refunds, and integrations.",
    icon: "settings"
  },
  [RoutesPaths.configure.auto_refund]: {
    title: "Configure",
    description: "View and manage your enrollments, refunds, and integrations.",
    queryParam: "auto-refund-logs",
    queryButtonText: "View logs",
    icon: "settings"
  },
  [RoutesPaths.home]: {
    title: "Home",
    description: "Here's an overview of your account.",
    icon: "homesidebar"
  },
  "/business_settings/my_business": {
    title: "My Business",
    description: "Manage your business profile and alert rules.",
    icon: "settings",
    buttonText: "Watch tutorial",
    videoUrl: "https://www.youtube.com/watch?v=x4cxRrXFjEk"
  },
  "/business_settings/billing": {
    title: "Billing & Invoices",
    description: "All information about your billing and invoices.",
    icon: "settings"
    //buttonText: "Watch tutorial",
    //videoUrl: "https://www.youtube.com/watch?v=f4RclD3ufD8",
  },
  "/business_settings/balance": {
    title: "Balance & Payment methods",
    description: "All information about your balance and payment methods.",
    icon: "settings"
  },
  "/business_settings/enrollment": {
    title: "Enrollment",
    description: "Turn on your coverage, you will only pay when we prevent a chargeback.",
    icon: "settings",
    buttonText: "Watch tutorial",
    videoUrl: "https://www.youtube.com/watch?v=nVcXJfPOo0U"
  }
}
